import React from "react";
import LoginOptions from "./LoginOptions";
import ForgotPasswordForm from "./ForgotPasswordForm";
import LoginForm from "./LoginForm";
import ModalWrapper from "../common/ModalWrapper";

export default function AuthModal(props) {
  const { logInOptions, forgotPassOptions } = props;

  return (
    <ModalWrapper id="logInModal">
      {logInOptions && <LoginOptions {...props} />}
      {forgotPassOptions && <ForgotPasswordForm {...props} />}
      {!logInOptions && !forgotPassOptions && <LoginForm {...props} />}
    </ModalWrapper>
  );
}
